import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "../../Constant/sidebar";
import TopBar from "../../Constant/TopBar";
import Footer from "../../Constant/Footer";
import { connect, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import * as userActions from "../../../actions/index";
import StudentInformationItem from "./StudentInformationItem";
import { TailSpin } from 'react-loader-spinner'
import Select from 'react-select';
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';
import IconButton from '@mui/material/IconButton';
import { Tooltip } from "@mui/material";

const StudentInformation = (props) => {
    const dispatch = useDispatch();
    const [showLoader, setShowLoader] = useState(false)
    const [filterlimit, setfilterlimit] = useState(10);
    const [filterpage, setfilterpage] = useState(1);
    const [filterorder, setfilterorder] = useState("asc");
    const [filtersort, setfiltersort] = useState("");
    const [filtersearch, setfiltersearch] = useState("");
    const [is_student_activate, setis_student_activate] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [count, setCount] = useState();
    const [class_ids, setclass_ids] = useState("");
    const [class_id, setclass_id] = useState([]);
    const [dormitory_ids, setdormitory_ids] = useState("");
    const [dormitory_id, setdormitory_id] = useState([]);
    const [dormitory_status, setdormitory_status] = useState(true);
    const [gender, setgender] = useState('');
    const [student_age] = useState([
        { label: "Select an Option", value: "" },
        { label: "4", value: "4" },
        { label: "5", value: "5" },
        { label: "6", value: "6" },
        { label: "7", value: "7" },
        { label: "8", value: "8" },
        { label: "9", value: "9" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" },
        { label: "13", value: "13" },
        { label: "14", value: "14" },
        { label: "15", value: "15" },
        { label: "16", value: "16" },
        { label: "17", value: "17" },
        { label: "18", value: "18" },
        { label: "19", value: "19" },
        { label: "20", value: "20" },
        { label: "21", value: "21" },
        { label: "22", value: "22" },
        { label: "23", value: "23" },
        { label: "24", value: "24" },
        { label: "25", value: "25" },
    ]);
    const [student_ages, setstudent_ages] = useState("");
    const [isCsv, setIsCsv] = useState(null);

    const navigate = useNavigate();
    const permission_info = JSON.parse(localStorage.getItem("permissions"));

    const customStyles = {
        // option: (provided, state) => ({
        //     ...provided,
        //     "&:hover": {
        //         backgroundColor: state.isFocused ? "#e7f5fe" : "",
        //     },
        //     backgroundColor: state.isSelected ? "#4a8fb8" : "",
        // }),

         option: (provided, state) => ({
  ...provided,
  "&:hover": {
    backgroundColor:
      !state.isSelected && state.isFocused ? "#e7f5fe" : "",
  },
  backgroundColor: state.isSelected ? "#4a8fb8" : "",
}),
    };

    const row_limit = [
        { value: 10, label: 10 },
        { value: 25, label: 25 },
        { value: 50, label: 50 },
        { value: 100, label: 100 }
    ]

    const DownloadCsvFile = async () => {
        try {
            debugger;
            const response = await GetStudentConfidentialDetails(true); // wait for result
            if (response && response?.file !== 'https://api.boardingschoolsoftware.com/undefined') {
                console.log("CSV file response:", response);
                const link = document.createElement("a");
                link.href = response.file;
                document.body.appendChild(link);
                console.log("Downloading file:", response.file);
                link.click(); // you forgot to click also (it was commented)
                link.parentNode.removeChild(link);
            } else {
                console.error("No file received in response");
                toast.error("Error downloading CSV file", {
                    position: toast.POSITION.TOP_CENTER,
                });
                return;
            }
        } catch (error) {
            console.error("Error downloading CSV file:", error);
        }

    }

    const GetStudentConfidentialDetails = useCallback(async (is_csv = false) => {
        const response = await dispatch(userActions.GetStudentConfidentialDetails(filterpage, filterlimit, filtersort, filterorder, filtersearch, is_student_activate, class_ids, dormitory_ids, gender, student_ages, is_csv))
        if (response.success === true) {
            const arrayData = response?.data.rows;
            setTableData(arrayData);
            setCount(response?.data.count);
            setIsCsv(response?.file)
            return response;
        } else if (response.status === 401) {
            toast.error(response.message, {
                position: toast.POSITION.TOP_CENTER,
            });
            setTimeout(() => {
                navigate('/logout')
            }, 5000);
        }
    }, [dispatch, filterpage, filterlimit, filtersort, filterorder, filtersearch, is_student_activate, class_ids, dormitory_ids, gender, student_ages]);

    useEffect(() => {
        GetStudentConfidentialDetails();
    }, [GetStudentConfidentialDetails, filterpage, filterlimit, filtersort, filterorder, filtersearch, is_student_activate, class_ids, dormitory_ids, gender, student_ages]);
    const GetAllClassesDetailsStudent = useCallback(() => {
        dispatch(userActions.GetAllClassesList()).then((response) => {
            if (response.success === true) {
                let state_data = [];
                state_data.push({
                    label: "Select an Option",
                    value: "",
                });
                const arrayData = response.data.rows;
                if (permission_info) {
                    const permClassDormArray = permission_info?.perm_class_dorm;
                    const filteredPermDorm = permClassDormArray?.filter(item => item?.class_id !== null)
                    const allowedDormIds = filteredPermDorm?.map(item => item?.class_id);
                    const filteredData = arrayData?.filter(item => allowedDormIds?.includes(item?.class_id));
                    for (let key in filteredData) {
                        state_data.push({
                            label: filteredData[key].class_name,
                            value: filteredData[key].class_id,
                            class_id: filteredData[key].class_id,
                        });
                    }
                } else {
                    for (let key in arrayData) {
                        state_data.push({
                            label: arrayData[key].class_name,
                            value: arrayData[key].class_id,
                            class_id: arrayData[key].class_id,
                        });
                    }
                }
                setclass_id(state_data);
            } else {

            }
        });
    }, [dispatch]);

    useEffect(() => {
        GetAllClassesDetailsStudent();
    }, []);

    const GetAllDormitoryStudent = useCallback(() => {
        dispatch(userActions.GetAllDormitory("", "", "", "", dormitory_status)).then((response) => {
            if (response.success === true) {
                let state_data = [];
                state_data.push({
                    label: "Select an Option",
                    value: "",
                });
                const arrayData = response.data.rows;
                if (permission_info) {
                    const permClassDormArray = permission_info?.perm_class_dorm;
                    const filteredPermDorm = permClassDormArray.filter(item => item?.dormitory_id !== null)
                    const allowedDormIds = filteredPermDorm.map(item => item?.dormitory_id);
                    const filteredData = arrayData.filter(item => allowedDormIds.includes(item.dormitory_id));
                    for (let key in filteredData) {
                        state_data.push({
                            label: filteredData[key].dormitory_name,
                            value: filteredData[key].dormitory_id,
                            dormitory_id: filteredData[key].dormitory_id,
                        });
                    }
                } else {
                    for (let key in arrayData) {
                        state_data.push({
                            label: arrayData[key].dormitory_name,
                            value: arrayData[key].dormitory_id,
                            dormitory_id: arrayData[key].dormitory_id,
                        });
                    }
                }
                setdormitory_id(state_data);
            } else {
                //notify.show(response.message, "error");
            }
        });
    }, [dispatch]);
    useEffect(() => {
        GetAllDormitoryStudent();
    }, []);
    return (
        <>
            {showLoader &&
                <div style={{ backdropFilter: "blur(10px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: "99999999", position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "#b8b8b82b" }}>
                    <div >
                        <TailSpin
                            visible={showLoader}
                            height="100"
                            width="100"
                            color="#3693d0"
                            ariaLabel="tail-spin-loading"
                            radius="1"
                            wrapperStyle={{}}
                            wrapperClass=""
                        />
                    </div>

                </div>
            }

            <div id="kt_body" className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-enabled aside-fixed">
                <div className="d-flex flex-column flex-root">
                    <div className="page d-flex flex-row flex-column-fluid">
                        <Sidebar />
                        <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
                            <TopBar />
                            <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
                                <div className="post d-flex flex-column-fluid" id="kt_post">
                                    <div id="kt_content_container" className="container-fluid">
                                        <div className="school-edit-form">
                                            <div className="" id="Snapshot">
                                                <div className="card-body p-0">
                                                    <div className="row">

                                                        <div className="col-lg-8">
                                                            <div className="card tabs-outer">
                                                               
                                                                <div className="card-header position-relative py-0 details-bg">
                                                                    <div className="d-flex justify-content-between align-items-center w-100">
                                                                        <h2 className="card-title m-0">Your Filtered List</h2>

                                                                        {/* Tooltip for Icon */}
                                                                        <div className="flex-grow-1 text-start">
                                                                            <Tooltip
                                                                                title="Filter your list to suit you ,when click the CSV icon on the right to download . You can pretty it up with any application you have on your computer :)"
                                                                                placement="bottom" >
                                                                                <i className="fas fa-question-circle ms-2"></i>
                                                                            </Tooltip>
                                                                        </div>

                                                                        {/* CSV Download Button */}
                                                                        <div className="d-flex align-items-center">
                                                                            <Tooltip title="Download .csv" placement="top">
                                                                                <IconButton onClick={() => DownloadCsvFile()}>
                                                                                    <i className="fas fa-file-csv" style={{fontSize: '24px'}}></i>
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                <div className="card-body">
                                                                    <div className="card-toolbar mb-6">
                                                                        <div className="d-flex align-items-center justify-content-between export-out">
                                                                            {/* <!-- <h4 className="card-title  m-0">Schools</h4> --> */}
                                                                            <div className="d-flex align-items-center position-relative">
                                                                                <span className="svg-icon svg-icon-1 position-absolute ms-4">
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                                                        <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor"></rect>
                                                                                        <path
                                                                                            d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                                                                                            fill="currentColor"
                                                                                        ></path>
                                                                                    </svg>
                                                                                </span>

                                                                                <input type="text" className="form-control form-control-sm w-350px ps-12 search-out fs-6" placeholder="Search " style={{ background: "transparent" }}
                                                                                    onChange={(event) => {
                                                                                        setfiltersearch(event.target.value);
                                                                                        setfilterpage(1);
                                                                                    }}

                                                                                />
                                                                            </div>
                                                                          
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        {/* <div className="col-sm-12">
                                                                            <StudentInformationItem
                                                                                // data={staticDuplicateList}
                                                                                filterpage={filterpage}
                                                                                filterlimit={filterlimit}
                                                                                data={tableData}
                                                                            />
                                                                        </div> */}
                                                                      <div className="col-sm-12">
  {tableData && tableData.length > 0 ? (
    <StudentInformationItem
      filterpage={filterpage}
      filterlimit={filterlimit}
      data={tableData}
    />
  ) : (
    <div className="text-center py-5">
      <h5>No Data Found</h5>
    </div>
  )}
</div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex justify-content-between mt-4">
                                                                <Select
                                                                    menuPlacement="top"
                                                                    className="basic-single"
                                                                    classNamePrefix="select"
                                                                    defaultValue={row_limit[0]}
                                                                    name="color"
                                                                    options={row_limit}
                                                                    onChange={(event) => { setfilterlimit(event.value); setfilterpage(1); }}
                                                                />
                                                                <Stack spacing={1} >
                                                                    <Pagination
                                                                        count={Math.ceil(count / filterlimit)}
                                                                        page={filterpage}
                                                                        onChange={(event, value) => setfilterpage(value)}
                                                                        color="primary"
                                                                    />
                                                                </Stack>
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-4">

                                                            <div className="card">
                                                                <div className="card-header border-bottom border-bottom-1">
                                                                    <h3 className="card-title align-items-start flex-column">
                                                                        <span className="card-label fw-bold text-dark">Filters</span>
                                                                    </h3>
                                                                </div>

                                                                <div className="card-body p-6">
                                                                    <div className="d-flex flex-column">
                                                                        <h5>Sort By</h5>
                                                                        <div className="d-flex">

                                                                            <button className=

                                                                                {"filter-badge me-2 filter-button " +
                                                                                    (filtersort === "" ? "btn btn-primary active-filter" : "btn btn-dark")
                                                                                }
                                                                                onClick={(event) => {
                                                                                    if (filterorder === 'desc') {
                                                                                        setfilterorder('asc');
                                                                                    }
                                                                                    else {
                                                                                        setfilterorder('desc');
                                                                                    }
                                                                                    setfiltersort("");
                                                                                    setfilterpage(1);

                                                                                }}

                                                                            >None</button>

                                                                            <button className=

                                                                                {"filter-badge me-2 filter-button " +
                                                                                    (filtersort === "student_first_name" ? "btn btn-primary active-filter" : "btn btn-dark")
                                                                                }
                                                                                onClick={(event) => {
                                                                                    if (filterorder === 'desc') {
                                                                                        setfilterorder('asc');
                                                                                    }
                                                                                    else {
                                                                                        setfilterorder('desc');
                                                                                    }
                                                                                    setfiltersort('student_first_name');
                                                                                    setfilterpage(1);

                                                                                }}

                                                                            >Name</button>

                                                                            <button className=

                                                                                {"filter-badge me-2 filter-button " +
                                                                                    (filtersort === "class_id" ? "btn btn-primary active-filter" : "btn btn-dark")
                                                                                }
                                                                                onClick={(event) => {
                                                                                    if (filterorder === 'desc') {
                                                                                        setfilterorder('asc');
                                                                                    }
                                                                                    else {
                                                                                        setfilterorder('desc');
                                                                                    }
                                                                                    setfiltersort('class_id');
                                                                                    setfilterpage(1);

                                                                                }}

                                                                            >Class</button>
                                                                            <button className=

                                                                                {"filter-badge me-2 filter-button " +
                                                                                    (filtersort === "student_id" ? "btn btn-primary active-filter" : "btn btn-dark")
                                                                                }
                                                                                onClick={(event) => {
                                                                                    if (filterorder === 'desc') {
                                                                                        setfilterorder('asc');
                                                                                    }
                                                                                    else {
                                                                                        setfilterorder('desc');
                                                                                    }
                                                                                    setfiltersort('student_id');
                                                                                    setfilterpage(1);
                                                                                }}

                                                                            >Student Id</button>

                                                                        </div>
                                                                    </div>

                                                                    <div className="d-flex flex-column mt-6">
                                                                        <h5>Show</h5>
                                                                        <div className="d-flex align-items-center">
                                                                            {/* <span className=
                                                                                {"filter-badge me-2 filter-button " +
                                                                                    (is_student_activate === "" ? "btn btn-primary active-filter" : "btn btn-dark")
                                                                                }
                                                                                onClick={(event) => {
                                                                                    setis_student_activate('');
                                                                                    setfilterpage(1);

                                                                                }}

                                                                            >Active</span>
                                                                            <span className=
                                                                                {"filter-badge me-2 filter-button " +
                                                                                    (is_student_activate === false ? "btn btn-primary active-filter" : "btn btn-dark")
                                                                                }
                                                                                onClick={(event) => {
                                                                                    setis_student_activate(false);
                                                                                    setfilterpage(1);

                                                                                }}

                                                                            >Inactive</span> */}
                                                                            <span className=
                                                                                {"filter-badge me-2 filter-button " +
                                                                                    (is_student_activate === null ? "btn btn-primary active-filter" : "btn btn-dark")
                                                                                }
                                                                                onClick={() => {
                                                                                    setis_student_activate(null);
                                                                                    setfilterpage(1);

                                                                                }}

                                                                            >All</span>
                                                                            <span className=
                                                                                {"filter-badge me-2 filter-button " +
                                                                                    (is_student_activate === true ? "btn btn-primary active-filter" : "btn btn-dark")
                                                                                }
                                                                                onClick={(event) => {
                                                                                    setis_student_activate(true);
                                                                                    setfilterpage(1);

                                                                                }}

                                                                            >Active</span>
                                                                            <span className=
                                                                                {"filter-badge me-2 filter-button " +
                                                                                    (is_student_activate === false ? "btn btn-primary active-filter" : "btn btn-dark")
                                                                                }
                                                                                onClick={(event) => {
                                                                                    setis_student_activate(false);
                                                                                    setfilterpage(1);

                                                                                }}

                                                                            >Inactive</span>
                                                                        </div>
                                                                    </div>

                                                                  


                                                                </div>
                                                            </div>
                                                            <div className="card tabs-outer">
                                                                <form id="search-form" >
                                                                    <div className="card-header border-bottom border-bottom-1 align-items-center">
                                                                        <h3 className="card-title align-items-start flex-column">
                                                                            <span className="card-label fw-bold text-dark">Student Search</span>
                                                                        </h3>
                                                                       
                                                                    </div>
                                                                    <div className="card-body add-new-schools p-6">
                                                                        <div className="row">
                                                                            <div className="col-lg-12 fv-row mb-5">
                                                                                <label className="fw-bold mb-2">Class</label>
                                                                                <Select
                                                                                    styles={customStyles}
                                                                                    className="react-bootstrap-typeahead tag-outer"
                                                                                    options={class_id}
                                                                                    value={class_id.filter(function (option) {
                                                                                        return option.value === class_ids;
                                                                                    })}
                                                                                    onChange={(event) => {
                                                                                        setclass_ids(event.value);
                                                                                    }}
                                                                                />
                                                                            </div>

                                                                            <div className="col-lg-12 fv-row mb-5">
                                                                                <label className="fw-bold mb-2">Select Dormitory</label>
                                                                                <Select
                                                                                    styles={customStyles}
                                                                                    className="react-bootstrap-typeahead tag-outer"
                                                                                    options={dormitory_id}
                                                                                    value={dormitory_id.filter(function (option) {
                                                                                        return option.value === dormitory_ids;

                                                                                    })}
                                                                                    onChange={(event) => {
                                                                                        setdormitory_ids(event.value);
                                                                                    }}
                                                                                />
                                                                            </div>

                                                                            <div className="col-lg-12 fv-row mb-5">
                                                                                <label className="fw-bold mb-2">Gender</label>
                                                                                <div className="d-flex">
                                                                                    <label className="cursor-pointer">
                                                                                        <input type="radio" id="gender" name="gen" className="form-check-input me-2 cursor-pointer" value="male" onChange={(event) => { setgender(event.target.value); }} />
                                                                                        Male
                                                                                    </label>

                                                                                    <label className="ms-8 cursor-pointer">
                                                                                        <input type="radio" id="gender1" name="gen" className="form-check-input me-2 cursor-pointer" value="female" onChange={(event) => { setgender(event.target.value); }} />
                                                                                        Female
                                                                                    </label>

                                                                                    <label className="ms-8 cursor-pointer">
                                                                                        <input type="radio" id="gender2" name="gen" className="form-check-input me-2 cursor-pointer" value="" onChange={(event) => { setgender(event.target.value); }} defaultChecked />
                                                                                        All
                                                                                    </label>
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-lg-12 fv-row mb-5">
                                                                                <label className="fw-bold mb-2">Select Age</label>
                                                                                <Select
                                                                                    styles={customStyles}
                                                                                    className="react-bootstrap-typeahead tag-outer"
                                                                                    options={student_age}
                                                                                    value={student_age.filter(function (option) {
                                                                                        return option.value === student_ages;
                                                                                    })}
                                                                                    onChange={(event) => {
                                                                                        setstudent_ages(event.value);

                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {


    onUpdateStudentStatus: userActions.UpdateStudentStatus,
    onUpdateStudentDuplicateStatus: userActions.UpdateStudentDuplicateStatus,
    onDeleteStudent: userActions.DeleteStudent,

};
export default connect(mapStateToProps, mapDispatchToProps)(StudentInformation);